import api from "./api"
import store from "../store/index"

export async function getOrderItemMessages({ orderID, orderItemID }) {
  const result = await api.get(
    `/api/v1/order/${orderID}/items/${orderItemID}/messages`,
    {
      params: {
        customerID: store.state.customerID ?? null,
      },
    }
  )
  return result.data
}

export async function createNewOrderItemMessage({
  orderID,
  orderItemID,
  message,
}) {
  const result = await api.post(
    `/api/v1/order/${orderID}/items/${orderItemID}/messages`,
    { message },
    {
      params: {
        customerID: store.state.customerID ?? null,
      },
    }
  )
  return result.data
}
